import { Divider } from '@mui/material';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import React from 'react';

import { LocationsListType } from './SelectLocationsOnMobile';

interface SelectListLocationProps {
  data: LocationsListType[] | [];
  handleSelectLocation: (event: LocationsListType) => void;
}

const SelectListLocation: React.FC<SelectListLocationProps> = ({ data, handleSelectLocation }) => {
  return (
    <>
      {data.map((list, index) => (
        <List key={list.value} dense disablePadding>
          <ListItem component="div" disablePadding>
            <ListItemButton onClick={() => handleSelectLocation({ name: list.name, value: list.value })}>
              <ListItemText primaryTypographyProps={{ fontSize: 18 }} primary={list.name} />
            </ListItemButton>
          </ListItem>
          <Divider light />
        </List>
      ))}
    </>
  );
};

export default SelectListLocation;
